/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  (function () {
    const observer = new MutationObserver(() => {
      document
        .querySelectorAll(".tolstoy-tile-name-container")
        .forEach((el) => {
          if (el.innerHTML.includes("&lt;b&gt;")) {
            el.innerHTML = el.innerHTML
              .replace(/&lt;b&gt;/g, "<b>")
              .replace(/&lt;\/b&gt;/g, "</b>");
          }
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


(function () {
  'use strict';
  var WRAP = '.delivery-options';

  function moneyFmt(cents) {
    var f = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function productData(section) {
    var el = section.querySelector('script[id^="ProductJson-"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function selectedVariant(section, data) {
    var chosen = data.options.map(function (o) {
      var c = section.querySelector('input[name="options[' + o + ']"]:checked');
      if (c) return c.value;
      var s = section.querySelector('select[name="options[' + o + ']"]');
      return s ? s.value : null;
    });
    if (chosen.indexOf(null) !== -1) return null;
    return data.variants.filter(function (v) {
      return v.options.length === chosen.length &&
             v.options.every(function (o, i) { return o === chosen[i]; });
    })[0] || null;
  }

  function sync(section) {
    var wrap = section.querySelector(WRAP);       if (!wrap) return;
    var data = productData(section);              if (!data) return;
    var variant = selectedVariant(section, data); if (!variant) return;

    Array.prototype.forEach.call(wrap.querySelectorAll('label'), function (row) {
      var input = row.querySelector('input[name="selling_plan"]');
      if (!input) return;
      var priceEl = row.querySelector('.delivery-options__price');
      var cmpEl   = row.querySelector('.delivery-options__compare');
      var price, compare;

      if (input.value) {
        var alloc = (variant.selling_plan_allocations || []).filter(function (a) {
          return String(a.selling_plan_id) === String(input.value);
        })[0];
        if (!alloc) return;
        price = alloc.price;
        compare = alloc.compare_at_price;
      } else {
        price = variant.price;
        compare = variant.compare_at_price;
      }

      if (priceEl) priceEl.textContent = moneyFmt(price);
      if (cmpEl) cmpEl.textContent = (compare && compare > price) ? moneyFmt(compare) : '';
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll(WRAP), function (wrap) {
      var section = wrap.closest('[id^="shopify-section"]') || document;
      sync(section);
      section.addEventListener('change', function (e) {
        if (e.target && /^options\[/.test(e.target.name || '')) sync(section);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
